/**
 * @see https://vuejs-tips.github.io/vue-the-mask/
 */
import Vue from 'vue';
import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask);
